import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBriefcaseOutline = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.25 3.375H10.5V2.0625C10.5 1.35156 9.89844 0.75 9.1875 0.75H4.8125C4.07422 0.75 3.5 1.35156 3.5 2.0625V3.375H1.75C0.765625 3.375 0 4.16797 0 5.125V12.125C0 13.1094 0.765625 13.875 1.75 13.875H12.25C13.207 13.875 14 13.1094 14 12.125V5.125C14 4.16797 13.207 3.375 12.25 3.375ZM4.375 2.0625C4.375 1.84375 4.56641 1.625 4.8125 1.625H9.1875C9.40625 1.625 9.625 1.84375 9.625 2.0625V3.375H4.375V2.0625ZM13.125 12.125C13.125 12.6172 12.7148 13 12.25 13H1.75C1.25781 13 0.875 12.6172 0.875 12.125V8.625H4.8125V10.375C4.8125 10.6211 5.00391 10.8125 5.25 10.8125H8.75C8.96875 10.8125 9.1875 10.6211 9.1875 10.375V8.625H13.125V12.125ZM5.6875 9.9375V8.625H8.3125V9.9375H5.6875ZM13.125 7.75H0.875V5.125C0.875 4.66016 1.25781 4.25 1.75 4.25H12.25C12.7148 4.25 13.125 4.66016 13.125 5.125V7.75Z",
		fill: "#FF8A80"
	})]
});
const ForwardRef = forwardRef(SvgBriefcaseOutline);
export { ForwardRef as ReactComponent };
